import { render } from "./AddAddressModal.vue?vue&type=template&id=574abfbc&scoped=true"
import script from "./AddAddressModal.vue?vue&type=script&lang=js"
export * from "./AddAddressModal.vue?vue&type=script&lang=js"

import "./AddAddressModal.vue?vue&type=style&index=0&id=574abfbc&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574abfbc"]])

export default __exports__